import type { Paginated } from '@field-support/shared';
import { api, type QueryValue } from './client';

/** Loads every page of a paginated endpoint (bounded by `maxItems`). */
export async function fetchAllPages<T>(path: string, query: Record<string, QueryValue> = {}, maxItems = 5000): Promise<T[]> {
  const items: T[] = [];
  for (let page = 1; ; page++) {
    const result = await api<Paginated<T>>(path, { query: { ...query, page, pageSize: 100 } });
    items.push(...result.items);
    if (items.length >= result.total || result.items.length === 0 || items.length >= maxItems) return items;
  }
}
